import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { TestdafDigitalResultDto } from '../shared/dto/testdaf-digital-result-dto';
import { CertificateService } from '../shared/services/certificate.service';

@Component({
  selector: 'app-verification-testdaf-digital',
  templateUrl: './verification-testdaf-digital.component.html',
  styleUrls: ['./verification-testdaf-digital.component.css']
})
export class VerificationTestdafDigitalComponent implements OnInit {

  subscription: Subscription;
  token: string;
  hash: string;
  result: TestdafDigitalResultDto;

  hideScores = false;

  constructor(
    private spinnerService: NgxSpinnerService,
    private route: ActivatedRoute,
    private certificationService: CertificateService) {
  }

  ngOnInit() {
    this.subscription = this.route.queryParams.subscribe(params => {
      this.token = params.token;
      this.hash = params.hash;
      this.certificationService.getTestdafDigitalResults(this.token, this.hash);
      this.spinnerService.show();
    });

    this.subscription.add(this.certificationService.testdafDigitalResultLoaded.subscribe(result => {
      this.result = result;
      if (this.result.format === 'papierbasierter TestDaF') {
        this.hideScores = true;
      }
      this.spinnerService.hide();
    }));
  }

  getTdn(tdnString: string) {
    const tdn = +tdnString;
    if (tdn < 3) {
      if (this.result.eventId === 860) {
        return '';
      } else {
        return 'TDN U3';
      }
    } else {
      return 'TDN ' + tdnString;
    }
  }
}
